<section class="section" style="padding-top: 8rem;">
  <div class="container content" style="max-width: 800px;">
    <h1>Mentions Légales</h1>
    <p style="font-style: italic; color: var(--muted); margin-bottom: 2rem;">
      Conformément aux dispositions de l'Article 6-III-1 de la Loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN).<br/>
      <a href="https://www.legifrance.gouv.fr/loda/article_lc/LEGIARTI000043964953" target="_blank" rel="noopener noreferrer" style="text-decoration: underline;">Consulter le texte officiel sur Legifrance</a>
    </p>

    <div class="card" style="margin-bottom: 2rem; padding: 2rem;">
      <h2>1. Éditeur du site</h2>
      <p>Le site <strong>www.mesh-box.fr</strong> est édité par :</p>
      <ul style="list-style: none; padding: 0; line-height: 1.8;">
        <li><strong>Raison sociale :</strong> Mesh Box</li>
        <li><strong>Représentant légal :</strong> Olivier Girodin (Président)</li>
        <li><strong>Siège social :</strong> 6 rue d'Armaillé, 75017 Paris</li>
        <li><strong>Bureaux secondaires :</strong> 72 rue Louis Lumière, 36000 Châteauroux</li>
        <li><strong>Téléphone :</strong> +33 7 82 43 11 28</li>
        <li><strong>Email :</strong> <a href="mailto:olivier.girodin&#64;mesh-box.fr">olivier.girodin&#64;mesh-box.fr</a></li>
        <li><strong>Agrément CII :</strong> Crédit Impôt Innovation n°29987181, délivré par la DRIEETS Île-de-France, valable du 01/01/2026 au 31/12/2030</li>
      </ul>
    </div>

    <div class="card" style="margin-bottom: 2rem; padding: 2rem;">
      <h2>2. Hébergement</h2>
      <p>Le site est hébergé par :</p>
      <ul style="list-style: none; padding: 0; line-height: 1.8;">
        <li><strong>Hébergeur :</strong> 1&1 IONOS SARL</li>
        <li><strong>Adresse :</strong> 7 Place de la Gare, 57200 Sarreguemines</li>
        <li><strong>Site web :</strong> <a href="https://www.ionos.fr" target="_blank" rel="noopener noreferrer">www.ionos.fr</a></li>
      </ul>
    </div>

    <div class="card" style="margin-bottom: 2rem; padding: 2rem;">
      <h2>3. Propriété Intellectuelle</h2>
      <p>
        L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. 
        Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
      </p>
      <p>
        La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est formellement interdite sauf autorisation expresse du directeur de la publication.
      </p>
    </div>

    <div class="card" style="padding: 2rem;">
      <h2>4. Données Personnelles</h2>
      <p>
        Les informations recueillies via le formulaire de contact sont destinées exclusivement à Mesh Box pour le traitement de votre demande.
        Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données.
      </p>
      <p>
        Pour plus d'informations, consultez notre <a routerLink="/privacy" style="font-weight: bold; color: var(--brand);">Politique de Confidentialité</a>.
      </p>
    </div>

  </div>
</section>